import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() full: boolean = false;
  @Input() width: string = "";
  @Input() minHeight: string = "";
  @Input() height: string = "";
}
